/* eslint-disable camelcase */
import axios from 'axios';
import { PRODUCT_RECOMMENDATION_ENDPOINT } from '@dynameat/constants';

export const PERIOD_NOT_CONFIRMED = 'period_not_confirmed';
export const PRODUCT_RECOMMENDATION_CONFLICT = 'product_recommendation_conflict';

export const productRecommendationListRequest = (parent_product__point_of_sale__guid) => axios.get(
  PRODUCT_RECOMMENDATION_ENDPOINT(),
  { params: { parent_product__point_of_sale__guid, page_size: 0 } }
);

export const createProductRecommendationRequest = (productRecommendationData) => axios.post(PRODUCT_RECOMMENDATION_ENDPOINT(), productRecommendationData);
export const editProductRecommendationRequest = (productRecommendationGuid, productRecommendationData) => axios.patch(PRODUCT_RECOMMENDATION_ENDPOINT(productRecommendationGuid), productRecommendationData);
export const removeProductRecommendationRequest = (productRecommendationGuid) => axios.delete(PRODUCT_RECOMMENDATION_ENDPOINT(productRecommendationGuid));
